// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Clipboard_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M18.75 3h-3.4a4.493 4.493 0 0 0-6.7 0h-3.4a1.5 1.5 0 0 0-1.5 1.5v15.75a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V4.5a1.5 1.5 0 0 0-1.5-1.5ZM12 3a3 3 0 0 1 3 3H9a3 3 0 0 1 3-3Zm6.75 17.25H5.25V4.5h2.508A4.5 4.5 0 0 0 7.5 6v.75a.75.75 0 0 0 .75.75h7.5a.75.75 0 0 0 .75-.75V6a4.5 4.5 0 0 0-.258-1.5h2.508Z',
  viewBox: '0 0 24 24',
  glyph: 'Clipboard_Stroke2_Corner2_Rounded',
})
